import { z } from 'zod'

/** What a balance is made of: this month's plan credits, share cashback and extra credits. */
export const creditBreakdownSchema = z.object({
  monthly: z.number().int().nonnegative(),
  cashback: z.number().int().nonnegative(),
  extra: z.number().int().nonnegative(),
})
export type CreditBreakdown = z.infer<typeof creditBreakdownSchema>

export const creditBalanceResponseSchema = z.object({
  businessId: z.string().uuid(),
  credits: z.number().int(),
  creditsUpdatedAt: z.string().datetime().nullable(),
  breakdown: creditBreakdownSchema,
})
export type CreditBalanceResponse = z.infer<typeof creditBalanceResponseSchema>

export const adjustCreditsRequestSchema = z.object({
  amount: z.number().int().positive(),
  reason: z.enum(['grant', 'purchase']),
})
export type AdjustCreditsRequest = z.infer<typeof adjustCreditsRequestSchema>
